import { Habit } from './storage'

// Date helpers
export const getLocalDateStr = (date: Date): string => {
  const offset = date.getTimezoneOffset() * 60000
  return new Date(date.getTime() - offset).toISOString().split('T')[0]
}

export const getTodayStr = (): string => getLocalDateStr(new Date())

export const getYesterdayStr = (): string => {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return getLocalDateStr(d)
}

export const getLast7Days = (): string[] => {
  return Array.from({ length: 7 }).map((_, i) => {
    const d = new Date()
    d.setDate(d.getDate() - (6 - i))
    return getLocalDateStr(d)
  })
}

// Habit logic
export const isCompletedToday = (habit: Habit): boolean => {
  return habit.completions.includes(getTodayStr())
}

export const wasMissedYesterday = (habit: Habit): boolean => {
  const yesterday = getYesterdayStr()
  const today = getTodayStr()
  // If it was created today or yesterday, don't penalize
  if (habit.createdAt >= yesterday) return false

  return (
    !habit.completions.includes(yesterday) && !habit.completions.includes(today)
  )
}

export const getStreak = (habit: Habit): number => {
  const completions = new Set(habit.completions)
  let streak = 0
  let currentDate = new Date()

  // If not completed today, start checking from yesterday
  if (!completions.has(getTodayStr())) {
    currentDate.setDate(currentDate.getDate() - 1)
  }

  while (true) {
    const dateStr = getLocalDateStr(currentDate)
    if (completions.has(dateStr)) {
      streak++
      currentDate.setDate(currentDate.getDate() - 1)
    } else {
      break
    }
  }

  return streak
}

export const getLongestStreak = (habit: Habit): number => {
  if (habit.completions.length === 0) return 0

  const sorted = [...habit.completions].sort()
  let longest = 1
  let current = 1

  for (let i = 1; i < sorted.length; i++) {
    const prevDate = new Date(sorted[i - 1])
    const currDate = new Date(sorted[i])
    const diffTime = Math.abs(currDate.getTime() - prevDate.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays === 1) {
      current++
      longest = Math.max(longest, current)
    } else if (diffDays > 1) {
      current = 1
    }
  }

  return longest
}

export const getWeekCompletions = (habit: Habit): boolean[] => {
  const last7Days = getLast7Days()
  const completions = new Set(habit.completions)
  return last7Days.map((date) => completions.has(date))
}

export const markComplete = (habit: Habit): Habit => {
  const today = getTodayStr()
  if (habit.completions.includes(today)) return habit

  return {
    ...habit,
    completions: [...habit.completions, today],
  }
}
